import React, { lazy } from 'react';
import { Section, FadeIn } from './ui/Section';
export function WhatIsAntiImpulso() {
  return <Section background="white" className="border-t border-[#E8D5DC]/50" data-id="element-283">
      <FadeIn data-id="element-284">
        <div className="text-center mb-12" data-id="element-285">
          <span className="text-[#C4467E] font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-286">
            El Concepto
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-[#3D1F2E] mb-6" data-id="element-287">
            Esto es Anti‑Impulso.
          </h2>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-288">
        <div className="prose prose-lg prose-stone mx-auto text-[#7A5C6B] leading-relaxed" data-id="element-289">
          <p className="text-xl md:text-2xl font-serif text-[#3D1F2E] mb-8 text-center" data-id="element-290">
            Un sistema de 14 días para cortar compras compulsivas sin volverte
            una persona "restrictiva" y sin vivir en guerra contigo.
          </p>

          <FadeIn delay={0.3} data-id="element-291">
            <div className="my-12" data-id="element-292">
              <img src="https://cdn.magicpatterns.com/uploads/h241stnUBcHgWd2SzzrFSw/Anti_impulso_cover.png" alt="Anti-Impulso — Vista del producto digital en laptop y celular" className="w-full max-w-2xl mx-auto rounded-2xl shadow-xl" loading="lazy" decoding="async" data-id="element-293" />
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-12" data-id="element-294">
            <div className="bg-[#FFF5F0]/80 backdrop-blur-sm p-6 rounded-xl text-center" data-id="element-295">
              <span className="text-3xl mb-4 block" data-id="element-296">🚫</span>
              <p className="font-medium text-[#3D1F2E]" data-id="element-297">
                No es un curso eterno.
              </p>
            </div>
            <div className="bg-[#FFF5F0]/80 backdrop-blur-sm p-6 rounded-xl text-center" data-id="element-298">
              <span className="text-3xl mb-4 block" data-id="element-299">📊</span>
              <p className="font-medium text-[#3D1F2E]" data-id="element-300">
                No es un Excel bonito que vas a abandonar.
              </p>
            </div>
            <div className="bg-[#FFF5F0]/80 backdrop-blur-sm p-6 rounded-xl text-center" data-id="element-301">
              <span className="text-3xl mb-4 block" data-id="element-302">💪</span>
              <p className="font-medium text-[#3D1F2E]" data-id="element-303">
                No es "échale ganas".
              </p>
            </div>
          </div>

          <p className="text-center text-lg" data-id="element-304">
            Es una estructura simple para que, cuando llegue el impulso,{' '}
            <span className="font-bold text-[#C4467E]" data-id="element-305">
              no tengas que negociar contigo misma.
            </span>
          </p>
        </div>
      </FadeIn>
    </Section>;
}